

document.addEventListener('DOMContentLoaded', () => {
	// Add selectors to a const variable
	const searchButton = document.querySelector(".tip-top-bar-mobile__search-button");
	const searchContainer = document.querySelector(".tip-top-bar-mobile__search");
	//On click, toggle active class on container
	if (searchButton && searchContainer) {
		searchButton.addEventListener('click', () => searchContainer.classList.toggle("active") );
	}
});

(() => {
	document.querySelectorAll('.tip-top-bar-mobile__menu-button').forEach(button => {
		button.addEventListener('click', () => {
			document.querySelector('body').classList.toggle('tip-top-bar-mobile__menu--open');
			button.classList.toggle('open');
			button.querySelectorAll('.buttonMenu').forEach(element => {
				element.classList.toggle('open');
			});
			document.querySelectorAll('.tip-top-bar-mobile__mobile-menu-container').forEach(container => {
				container.classList.toggle('open');
			});
		});
	});
	document.querySelectorAll('.close-menu-button, .tip-top-bar-mobile__close-menu-button').forEach(button => {
		button.addEventListener('click', (event) => {
			document.querySelector('body').classList.toggle('tip-top-bar-mobile__menu--open');
			event.preventDefault();
			document.querySelectorAll('.tip-top-bar-mobile__menu-button .buttonMenu').forEach(element => {
				element.classList.toggle('open');
			});
			document.querySelectorAll('.tip-top-bar-mobile__mobile-menu-container').forEach(container => {
				container.classList.remove('open');
			});
		});
	});
})();
